import { ModuleProps, CreateModuleProps } from "components";
import { Routes } from "./Routes";
import { Rights } from "./Rights";

export const Module: ModuleProps = CreateModuleProps({
    id: "MY_HISTORY",
    applicationRights: Rights,
    title: 'Min historikk',
    text: 'Min historikk',
    icon: 'clock-counter-clockwise',
    showOnDashboardByDefault: false,
    url: "/history",
    mobileThreshold: 1024,
    sequenceNo: 4000,
    routes: Routes
})
